import { Alert, Button, Input, Modal } from "antd";
import { useEffect, useState } from "react";

export interface RevokeDialogProps {
    open: boolean;
    loading?: boolean;
    disabled?: boolean;
    onCancel: () => void;
    onConfirm: (reason: string) => void;
}

/** 账户预付款撤销弹窗，保持旧 Vue 的备注字段、长度限制和确认回调契约。 */
export default function RevokeDialog({
    open,
    loading = false,
    disabled = false,
    onCancel,
    onConfirm
}: RevokeDialogProps) {
    const [reason, setReason] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        if (!open) {
            setReason("");
            setError("");
        }
    }, [open]);

    const submit = () => {
        const value = reason.trim();
        if (!value) {
            setError("请输入撤销原因");
            return;
        }
        setError("");
        onConfirm(value);
    };

    return (
        <Modal
            title="撤销"
            open={open}
            okText="确定"
            cancelText="取消"
            confirmLoading={loading}
            okButtonProps={{ disabled }}
            onCancel={onCancel}
            onOk={submit}
        >
            <Input.TextArea
                aria-label="撤销原因"
                autoSize={{ minRows: 3, maxRows: 3 }}
                maxLength={100}
                placeholder="请输入撤销原因"
                showCount
                value={reason}
                onChange={event => {
                    setReason(event.target.value);
                    if (error) setError("");
                }}
            />
            {error ? <Alert className="mt-2" message={error} role="alert" type="error" /> : null}
            <Button className="hidden" htmlType="submit" />
        </Modal>
    );
}
